<template>
  <div>
    <Scroll ref="scroll" :class="$style.wrapper" :pullup="true" @bsPullingUp="bsPullingUp">
      <div>
        <TopHeader headerTitle="我的消息" :isShowMenuIcon="false" />
        <div :class="$style.line"></div>
        <!-- 未注册时显示 -->
        <div v-if="!isRegister" :class="$style.empty">
          <div>您还未注册论坛账号哦，注册后看看谁和您互动过吧~</div>
          <div :class="$style.btn" @click="handleRegister">点击前往注册</div>
          <img :src="emptyImage" />
        </div>
        <div v-if="hasNewsList && isRegister">
          <NewsItem v-for="item of newsList" :key="item.id" :newsItem="item" />
        </div>
        <!-- 无消息时显示 -->
        <div v-if="!hasNewsList && isRegister" :class="$style.empty">
          <div>暂时没有消息哦~</div>
          <img :src="emptyImage" />
        </div>
        <div ref="tips" :class="$style.nomore">
          <p v-if="noMore">—— 没有更多消息了 ——</p>
        </div>
      </div>
    </Scroll>
  </div>
</template>

<script>
import Scroll from '_c/Scroll';
import TopHeader from '_c/TopHeader';
import NewsItem from './components/NewsItem';
import { getUserMessage } from '@/api/personalCenter';
import { reportData } from '@/api/report';
import { mapActions, mapState, mapMutations } from 'vuex';
import { CDN_URL } from "@/config/index.js";
export default {
  components: {
    Scroll,
    TopHeader,
    NewsItem,
  },
  data() {
    return {
      newsList: [],
      currentPage: 1,
      noMore: false,
      emptyImage: `${CDN_URL}/empty.png`, // 无回复滑稽黑猫图片
    };
  },
  computed: {
    ...mapState('account', {
      userInfo: state => state.userInfo
    }),
    // 判断是否注册论坛
    isRegister() {
      let flag = this.userInfo.forum_user_id != 0 ? true : false
      return flag;
    },
    hasNewsList() {
      return this.newsList.length > 0 ? true : false
    }
  },
  created() {
    reportData({
      type: 9
    })
    this.getUserMessage()
  },
  methods: {
    ...mapMutations('app', {
      CHANGE_REGISTER_DIALOG: 'CHANGE_REGISTER_DIALOG'
    }),
    async getUserMessage() {
      const r = await getUserMessage({ limit: 10, page: this.currentPage })
      // 加载列表为空
      if (!r.data.data.length && r.data.total) {
        this.noMore = true
        return
      }
      if (this.currentPage == 1) {
        this.newsList = [...r.data.data]
      } else {
        this.newsList = this.newsList.concat([...r.data.data])
      }
      setTimeout(() => {
        this.$refs.scroll.refresh();
      }, 10);
    },
    // 上拉加载
    bsPullingUp() {
      this.currentPage++
      setTimeout(() => {
        this.getUserMessage()
      }, 10);
    },
    // 点击注册
    handleRegister() {
      this.CHANGE_REGISTER_DIALOG(true)
    }
  },
}
</script>

<style lang='scss' module>
.wrapper {
  width: 100%;
  height: calc(100vh - 50px);
}
.line {
  width: 100%;
  height: 1px;
  background-color: #efefef;
}
.empty {
  width: 100%;
  height: 300px;
  > div {
    position: relative;
    top: 43px;
    left: 50%;
    transform: translate3d(-50%, 0, 0);
    margin-bottom: 13px;
    width: 100%;
    text-align: center;
    font-size: 10px;
    font-weight: 400;
    color: rgba(159, 159, 159, 1);
    line-height: 13px;
  }
  > img {
    position: relative;
    top: 43px;
    left: 50%;
    transform: translate3d(-50%, 0, 0);
    width: 218px;
    height: auto;
  }
  .btn {
    width: 100px;
    height: 25px;
    border: 1px solid rgba(69, 175, 243, 1);
    border-radius: 12px;
    font-size: 10px;
    color: rgba(69, 175, 243, 1);
    line-height: 25px;
    text-align: center;
  }
}
.nomore {
  height: 50px;
  line-height: 50px;
  font-size: 12px;
  text-align: center;
  color: rgba(159, 159, 159, 1);
}
</style>